import React from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom'
import { ConnectedRouter as Router } from 'react-router-redux'

import { history } from 'store';
import App from 'containers/App';
import FourOhFourPage from 'containers/FourOhFourPage';

const authedRoutes = [
  { path: '/',
    exact: true,
    redirectTo: '/channels'
  },
  { path: '/channels',
    component: require('./containers/ChannelsPage').default,
    routes: [
      { path: '/channels',
        exact: true,
        component: require('./containers/ChannelsPage/ChannelList').default,
      },
      { path: '/channels/new',
        exact: true,
        component: require('./containers/ChannelsPage/NewChannel').default,
      },
      { path: '/channels/:channelId/edit',
        exact: true,
        component: require('./containers/ChannelsPage/EditChannel').default,
      },
    ]
  },
  { path: '/account',
    exact: true,
    component: require('./containers/AccountPage').default
  },
  { path: '/memento-plan',
    exact: true,
    component: require('./containers/MementoPlan').default
  },
  {
    path: '/nice-choice/:planId/:cost/:discount',
    exact: true,
    component: require('./containers/NiceChoice').default
  },
  {
    path: '/terms',
    exact: true,
    component: require('./containers/TermsPage').default,
  },
  { path: '/leads',
    component: require('./containers/LeadsPage').default,
    routes: [
      { path: '/leads',
        exact: true,
        component: require('./containers/LeadsPage/LeadsList/index').default,
      },
      { path: '/leads/:channelId',
        exact: true,
        component: require('./containers/LeadsPage/LeadsList/index').default,
      }
    ]
  },
  { path: '/analytics',
    component: require('./containers/AnalyticsPage').default,
    routes: [
      { path: "/analytics",
        exact: true,
        component: require("./containers/AnalyticsPage/AnalyticsRoot").default,
      },
      { path: '/analytics/:channelId',
        exact: true,
        component: require('./containers/AnalyticsPage/ChannelAnalytic').default,
      },
    ]
  }
];

const unauthedRoutes = [
  {
    path: '/terms',
    exact: true,
    component: require('./containers/TermsPage').default,
  },
  { path: '/',
    exact: true,
    redirectTo: '/sign-in'
  },
  { path: '/sign-in',
    exact: true,
    component: require('./containers/SignInPage').default
  },
  { path: '/sign-up',
    exact: true,
    component: require('./containers/SelfSignUp').default
  },
  { path: '/forgot-password',
    exact: true,
    component: require('./containers/ForgotPasswordPage').default
  },
  { path: '/api/users/confirmation/:token',
    exact: false,
    component: require('./containers/ConfirmEmailPage/index.js').default
  }
  // { path: '/self-sign-up',
  //   exact: true,
  //   component: require('./containers/SignUpPage').default
  // },
];

// export to be reused when routes need to be nested inside containers
export const RouteSubRoutes = (r) =>
  <Route
    path={r.path}
    exact={r.exact}
    render={props =>
      r.redirectTo
        ? <Redirect to={r.redirectTo} />
        : <r.component routes={r.routes} {...props} />
    }
  />

const AppWithRouter = withRouter(
  class extends React.PureComponent {
    componentDidUpdate(prevProps) {
       if (this.props.location !== prevProps.location) {
         return document.querySelector('body').scrollTop = 0;
       }
     }

    render() {
      return (<App {...this.props}/>);
    }
  }
);

const Routes = () =>
  <Router history={history}>
    <AppWithRouter switchComponent={({ authenticated: authed }) =>
      <Switch>
        {/* Routes generated determined by authentication */}
        {(authed ? authedRoutes : unauthedRoutes).map((r, i) =>
          <RouteSubRoutes key={i} {...r}/>
        )}

        {authed && unauthedRoutes.map((r,i) =>
          <RouteSubRoutes key={i+authedRoutes.length} {...r} redirectTo='/channels'/>
        )}

        {/* Routes accessible when authentication does not matter */}
        <Route component={FourOhFourPage}/>
      </Switch>
    }/>
  </Router>

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js